// extracted by mini-css-extract-plugin
export default {"Outer":"AddCategory_Outer__oAiwL","bigButton":"AddCategory_bigButton__nxV-2"};